var map = {
	"./bn/main.yml": 41,
	"./de/main.yml": 42,
	"./en/main.yml": 43,
	"./es/main.yml": 44,
	"./fr/main.yml": 45,
	"./gd/main.yml": 46,
	"./it/main.yml": 47,
	"./ru/main.yml": 48,
	"./si/main.yml": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 141;